<template>
  <div class="mt-4">
    <div v-if="buffets.length > 0" class="border-gray-200 border-b border-t border-r border-l rounded-lg mb-3">
      <Table :headers="headers" :data="buffets" :row-key="[
        'id',
        'created',
        'valid_to',
        'order',
        'Orderlinekey',
        'original_transaction_id',
        'orderlinesOfferName',
        'is_restore',
        'status']" :current-page="currentPage" :isLoading="isLoading" :per-page="perPage">
        <template #header-valid-to="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                </svg>
              </span>
            </button>
          </div>
        </template>
        <template #header-created="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                </svg>
              </span>
            </button>
          </div>
        </template>
        <template #actions="{ row }">

          <svg @click="showModal(row)" class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
              d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
              clip-rule="evenodd" />
            <path fill-rule="evenodd"
              d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
              clip-rule="evenodd" />
          </svg>

        </template>
        <template #created="{ value }">
          <span class="text-sm">{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <template #valid_to="{ value }">
          <span class="text-sm">{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <template #order="{ row }">
          {{ row.orderlines ? row.orderlines.order_id : "-" }}
        </template>
        <template #Orderlinekey="{ row }">
          {{ row.orderlines ? row.orderlines.id : "-" }}
        </template>
        <template #orderlinesOfferName="{ row }">
          {{ row.orderlines ? row.orderlines.name : "-" }}
        </template>
        <template #is_restore="{ row }">
          <div v-if="row.is_restore == true">
            <i class="fa fa-check"></i>Restore
          </div>
          <div v-else>
            -
          </div>
        </template>
        <template #status="{ row }">
          <div style="width: 100px">
            <span v-if="isActive(row.valid_to)" class="bg-green-100 px-2 py-1 rounded-lg text-sm text-green-800">
              Active
            </span>
            <span v-else class="bg-gray-100 text-gray-800 px-2 py-1 text-sm rounded-lg">
              Inactive
            </span>
          </div>
        </template>
      </Table>
    </div>
    <div v-else
      class="relative mt-4 overflow-x-auto my-2 mb-4 rounded-lg  border-gray-200 border-b border-t border-r border-l">
      <table v-if="!isLoading" class="min-w-full h-64 text-sm rounded-lg text-left">
        <thead class="bg-gray-50 text-gray-700">
          <tr class="text-center uppercase">
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              No</th>
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              Buffet Id</th>
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              created Date</th>
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              valid to Date</th>
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              Order ID</th>
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              Orderline Key</th>
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              original transaction id</th>
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              Offer Name</th>
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              restore</th>
            <th
              class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">
              Status</th>

          </tr>
        </thead>
        <tbody class="bg-white w-full">
          <tr>
            <td colspan="10" class="text-center py-8 text-gray-500">
              <div class="flex-col items-center justify-center flex-nowrap flex" style="height: 574px;">
                <svg class="w-14 h-14 text-gray-500 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
                </svg>
                <h4 class="text-base text-gray-600 mb-0">No Data</h4>
                <p class="text-sm text-gray-500">There are no data to display</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <t-modal ref="modalAction">
      <div class="text-sm flex-col justify-start items-start text-left">
        <p class="text-base font-semibold text-gray-900 mb-2">Update Buffets</p>
        <Datetime :timeDate="false" class="mt-3 w-full mr-1.5" :label="'Valid To'" v-model="date"></Datetime>
        <div class="flex justify-start mb-2 mt-3">
          <button @click="onSubmit" class="bg-blue-700 rounded-lg px-2 py-2 text-white mr-3">Save</button>
          <button @click="onReset" class="border  px-2 py-2 rounded-lg">Cancel</button>
        </div>

      </div>
    </t-modal>

  </div>
</template>

<script>
import moment from "moment";
import Table from '@/components/form/table'
import Datetime from '@/components/form/Datetime'
import { EventBus } from '../../event-bus'
import { mapActions, mapState } from "vuex";
export default {
  components: {
    Table,
    Datetime
  },
  name: "UserBuffets",
  props: {
    user: {
      type: String,
      required: true,
    },
    buffets: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      modal: false,
      sorts: [],
      sortString: [],
      BuffetsDetail: {},
      date: new Date().toString(),
      headers: [
        { label: 'No', key: '' },
        { label: 'Buffet ID', key: 'id' },
        { label: 'created Date', key: 'created', slotHeader: 'header-created' },
        { label: 'valid to Date', key: 'valid_to', slotHeader: 'header-valid-to' },
        { label: 'Order ID', key: '' },
        { label: 'Orderline Key', key: '', },
        { label: 'original transaction id', key: 'original_transaction_id' },
        { label: 'Offer Name', key: '', },
        { label: 'restore', key: '', },
        { label: 'Status', key: '', },

      ],
    };
  },
  computed: {
    ...mapState({
      isLoadingDelete: (state) => state.buffets.isLoadingDelete,
      message: (state) => state.buffets.message,
      isLoadingBuffets: (state) => state.users.isLoading,
      totalRows: (state) => state.users.totalRows,
    }),
  },
  methods: {
    ...mapActions("users", ["fetchBuffets"]),
    ...mapActions("buffets", ["updateBuffetByid", "buffetDelete"]),
    showModal(item) {
      // this.modal = true;
      this.$refs.modalAction.show();
      this.BuffetsDetail = item;
    },
    actionGetBuffet() {
      let email = this.user;
      let data = {
        email: email,
        page: this.currentPage,
        limit: this.perPage
      };
      this.fetchBuffets(data);
    },
    sortBy(column) {
      let existingIndex = this.sorts.findIndex(s => s.column === column);

      if (existingIndex >= 0) {
        this.sorts[existingIndex].order =
          this.sorts[existingIndex].order === "asc" ? "desc" : "asc";

        const [item] = this.sorts.splice(existingIndex, 1);
        this.sorts.unshift(item);
      } else {
        this.sorts.unshift({ column, order: "asc" });
      }

      this.sortString = this.sorts
        .map(s => `${s.column}_${s.order}`)
        .join(",");
      this.$emit("sort-data", this.sortString);
      let email = this.user;
      let data = {
        email,
        sort: this.sortString,
        page: this.currentPage,
        limit: this.perPage,
      };

      this.fetchBuffets(data);
    },
    formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss'),
      };
    },
    isActive(date) {
      return moment(date).isAfter(moment());
    },
    onReset() {
      this.$refs.modalAction.hide();
    },
    async onSubmit(e) {
      e.preventDefault();
      let payload = {
        valid_to: moment(this.date).format("YYYY-MM-DD hh:mm:ss"),
        id: this.BuffetsDetail.id,
        user_id: this.BuffetsDetail.user_id,
        orderline_id: this.BuffetsDetail.orderlines
          ? this.BuffetsDetail.orderlines.id
          : 0,
      };

      try {
        const result = await this.updateBuffetByid(payload);
        if (result) {
          this.actionGetBuffet();
          this.$refs.modalAction.hide();
          EventBus.$emit('show-toast', {
            message: `Success Update`,
            type: 'success',
          });
        }
      } catch (error) {
        EventBus.$emit('show-toast', {
          message: error,
          type: 'error',
        });
      }
      this.modal = false;
    },
    isValid(date) {
      let now = Date.now();
      if (moment(date).isSameOrAfter(now)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
